import { Component } from '@angular/core';
import { LegendComponent, LegendPosition } from '@realpage-da/ng-map';
import { MarketMarkerComponent } from '~/features/market/components/map';
import { PropertyMarkerComponent } from '~/features/property/components/map';


@Component({
  selector: 'market-legend',
  templateUrl: './market-legend.component.html',
  styleUrls: ['./market-legend.component.scss']
})
export class MarketLegendComponent extends LegendComponent {

  legendPosition: LegendPosition = LegendPosition.LEFT_BOTTOM;

}



// WEBPACK FOOTER //
// ./src/app/features/market/components/map/market-legend.component.ts